import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { DateTimeDisplay } from 'ui-components/components/date-time-display/date-time-display';

import Global from '../../../../../store/global-selectors';
import { ltlShipmentsGridMessages } from '../messages';

const EMPTY_DISPLAY = '\u2014';

const QuoteExpiration = ({ freightShipmentId }: { freightShipmentId: string }) => {
  const shipment = useSelector((state) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId }));

  if (!shipment?.quoteExpirationDate) {
    return EMPTY_DISPLAY;
  }

  return <DateTimeDisplay utcTimestamp={shipment.quoteExpirationDate} />;
};

export const quoteExpiration = {
  getMessageDescriptor: () => ltlShipmentsGridMessages.quoteExpiration,
  name: <FormattedMessage {...ltlShipmentsGridMessages.quoteExpiration} />,
  id: 'quoteExpiration',
  width: 120,
  minWidth: 80,
  index: 9,
  render: (data: { id: string }) => <QuoteExpiration freightShipmentId={data.id} />,
};
